
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/sanity",
      function () {
        return require("private-next-pages/destinations/sanity.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/sanity"])
      });
    }
  